import React from 'react';
import PropTypes from 'prop-types';
import { ConsolidatedPaperCenterComponent } from './ConsolidatedPaperCenterComponent';

const ConsolidatedPaperCenterContainer = ({
  header,
  chart,
  infoPapers,
  isLoading = false,
}) => {
  return (
    <ConsolidatedPaperCenterComponent
      header={header}
      chart={chart}
      infoPapers={infoPapers}
      isLoading={isLoading}
    ></ConsolidatedPaperCenterComponent>
  );
};

ConsolidatedPaperCenterContainer.propTypes = {
  header: PropTypes.object.isRequired,
  chart: PropTypes.object,
  infoPapers: PropTypes.object,
  isLoading: PropTypes.bool,
};

export { ConsolidatedPaperCenterContainer };
